import { lazy, Suspense } from 'react';
import { Box, Flex, Tooltip } from '@chakra-ui/react';
import { SideNavControl, TopNavSearchBar, UserProfile } from './components';
import holidayBanner from '../../assets/svg/nav/hb.png';
import { Announcement02 } from '@kula-ai/icons-core';

const Snowfall = lazy(() => import('react-snowfall'));
import { QuickCreateOptions } from './components/QuickCreateOptions';
import { useIsMobile } from '@/hooks/use-IsMobile';

const BeamerIcon = () => {
  return (
    <Box id="showBeamer">
      <Tooltip label="What's New">
        <Flex
          width="36px"
          height="36px"
          alignItems="center"
          justifyContent="center"
          className="default"
          borderRadius="10px"
          cursor="pointer"
        >
          <Announcement02
            size={18}
            color="var(--kula-colors-white)"
            className="kula-icon"
          />
        </Flex>
      </Tooltip>
    </Box>
  );
};
export const TopNavBar = () => {
  const isMobile = useIsMobile();
  if (isMobile) return null;
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  let showBanner = currentMonth === 11 || currentMonth === 0;

  if (currentMonth === 0 && currentDay >= 10) {
    showBanner = false;
  }

  return (
    <Box position={'relative'}>
      <Flex
        p="6px 17px"
        w="100%"
        alignItems="center"
        backgroundImage={
          showBanner
            ? `url(${holidayBanner})`
            : 'linear-gradient(180deg, #1B194D 0%, #121133 100%)'
        }
        backgroundSize="cover"
        backgroundPosition="bottom 0px right -30px;"
      >
        <SideNavControl />
        <TopNavSearchBar />
        <Flex gap="6px" alignItems="center">
          {import.meta.env.VITE_BEAMER_ID && <BeamerIcon />}
          <QuickCreateOptions />
          <UserProfile />
        </Flex>
        {showBanner && (
          <Suspense fallback={null}>
            <Snowfall snowflakeCount={20} speed={[0, 0.1]} wind={[0, 0.3]} />
          </Suspense>
        )}
      </Flex>
    </Box>
  );
};
